export default __webpack_public_path__ + "static/media/elePerson_2_1.3b0f417e.png";